import storage from "./storage.js";

function getStorageObject() {
    let storageObj = null;
    if (storage !== undefined) {
        storageObj = storage(storage.metadata.RUN_CONFIG);
    }
    return storageObj;
}

function getRunConfig(_runConfig) {
    let returnConfig = _runConfig || {};
    let storedConfig = getStorageObject() || {};

    for (let configKey in storedConfig) {
        if (storedConfig.hasOwnProperty(configKey)) {
            returnConfig[configKey] = storedConfig[configKey];
        }
    }

    return returnConfig;
}

export default {
    getRunConfig: getRunConfig
};
